<script lang="ts">
	import { page } from '$app/stores';
	import { showLocationOptions } from '$lib/stores/shopStore';
	import Wysiwyg from '../inputs/WYSIWYG.svelte';
	import { fade } from 'svelte/transition';

	import LangSwitcher from '$lib/components/util/LangSwitcher.svelte';
	import LocationSwitcher from '$lib/components/util/LocationSwitcher.svelte';
	import LocationsSwitcherBar from '$lib/components/util/LocationsSwitcherBar.svelte';
	import { EU_COUNTRIES } from '$lib/util/ecom/countries';

	export let headerCollapsed: boolean;

	let showRegionalBanner: false;
	let bannerText: string;
	let bannerLink: string;

	function getBannerText(location: string): string {
		if (location === 'AT') {
			return $page.data.globals.banner_text_at;
		} else if (EU_COUNTRIES.includes($page.data.location)) {
			return $page.data.globals.banner_text_eu;
		} else {
			return $page.data.globals.banner_text_world;
		}
	}

	function onBannerClick() {
		window.location.href = '/' + $page.params.lang + '/' + bannerLink;
	}

	function setCookie(cname: string, cvalue: string, exdays: number) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}

	function selectLocation(location: string) {
		showLocationOptions.set(false);
		setCookie('location', location, 365);
		window.location.reload();
	}

	$: {
		let link = $page.data.globals.banner_link;
		if (link && (link.type === 'internal' || (link.type === 'category' && page))) {
			bannerLink = link.page?.slug;
			if (link.parameters) {
				bannerLink += link.parameters;
			}
		} else {
			bannerLink = link;
		}
	}

	$: {
		bannerText =
			showRegionalBanner || !$page.data.globals.banner_text_all
				? getBannerText($page.data.location)
				: $page.data.globals.banner_text_all;
	}
</script>

<div class="banner" class:collapsed={headerCollapsed}>
	<div class="inner-banner">
		<div class="placeholder" />
		<div on:click={onBannerClick} class="text">
			{#key bannerText}
				<div class="banner-text" in:fade={{ duration: 1000 }}>
					<Wysiwyg text={bannerText} />
				</div>
			{/key}
		</div>
		<div class="switchers">
			<div class="lang-switcher">
				<LangSwitcher />
			</div>

			<div class="location-switcher">
				<LocationSwitcher
					on:click={() => {
						showLocationOptions.set(!$showLocationOptions);
					}}
				/>
			</div>
		</div>
	</div>
</div>
<LocationsSwitcherBar
	open={$showLocationOptions}
	on:close={() => {
		showLocationOptions.set(false);
	}}
	on:onlocationchange={(event) => {
		selectLocation(event.detail.location);
	}}
/>

<style lang="scss">
	$banner-height: v(header__banner__height);

	.banner {
		position: fixed;
		top: 0;
		width: 100%;
		height: $banner-height;
		display: flex;
		justify-content: center;
		padding: 0 v(page-padding);

		text-align: center;
		background-color: color(grey_07);
		color: color(white);
		z-index: 101;
		@include font(text-xs);
		// font-weight: bold;
		letter-spacing: 0.07em;
		@include transition(all);
		cursor: pointer;

		.inner-banner {
			width: 100%;
			height: 100%;
			// max-width: v(max-width);
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			justify-content: center;
			align-items: center;

			@include media(phone) {
				@include font(text-sm);
				grid-template-columns: 1fr;
			}
		}

		.text {
			width: 100%;
		}

		&.collapsed {
			transform: translateY(calc(-1 * $banner-height));
			top: 0;
		}

		:global(p) {
			margin-bottom: 0 !important;
		}

		:global(a) {
			width: 100%;
			height: 100%;
			color: inherit;
			display: flex;
			align-items: center;
			justify-content: center;
			text-decoration: none;
			transition: all 0.8s ease;
			transition-delay: 0s;
		}

		.switchers {
			display: flex;
			justify-content: flex-end;
			gap: 16px;
		}

		@include media(phone) {
			.placeholder {
				display: none;
			}

			.switchers {
				display: none;
			}
		}
	}
</style>
